import { Injectable } from "@angular/core";
import { AppConfig } from "../configs/app";
import { CommonService } from "./common.service";

@Injectable({
  providedIn: "root",
})
export class AffiliateService {
  constructor(
    private appConfig: AppConfig,
    private commonService: CommonService
  ) {}

  saveAcdCode(acdCode: string) {
    let expiredSeconds;
    switch (acdCode) {
      case "afb":
      case "ari":
      case "fan":
        expiredSeconds = 86400; // 24 hours
        break;
      default:
        expiredSeconds = 100 * 365 * 86400; // ~ 100 years
        break;
    }
    const expired = new Date().getTime() + expiredSeconds * 1000;
    const data = { code: acdCode, expired };

    const key =
      this.appConfig.localStoragePrefixName +
      this.commonService.appConfig.plan.acdCodeSessionName;
    localStorage.setItem(key, JSON.stringify(data));
  }

  getAcdCode() {
    const key =
      this.appConfig.localStoragePrefixName +
      this.commonService.appConfig.plan.acdCodeSessionName;
    let data: any = localStorage.getItem(key);
    data = JSON.parse(data);
    /* CHECK EXPIRED */
    if (data !== null && data.expired && data.expired < new Date().getTime()) {
      localStorage.removeItem(key);
      return null;
    }
    return data !== null ? data : null;
  }

  getEmbedAFBCodeLP() {
    return `
            <script>
                if (!window.afblpcvLpConf) {
                    window.afblpcvLpConf = [];
                }
                window.afblpcvLpConf.push({
                    siteId: "bb9a2f49"
                });
                window.afblpcvLinkConf = {
                    siteId: "bb9a2f49",
                    mode: "all"
                };
            </script>
            <script src="https://t.afi-b.com/jslib/lpcv.js?cid=bb9a2f49&pid=H124399" async="async"></script>
        `;
  }

  getEmbedARICodeLP() {
    return `
            <script>
                if (!window.ariConf) {
                    window.ariConf = [];
                }
                window.ariConf.push({ct: "5z7uxkcimask4kk0wow8"});
            </script>
            <script src="https://cro.fi-tsunagu.com/assets/ari/js/ari.js" async="async"></script>
        `;
  }
}
